/**
 * ECharts, tree-shaken: `echarts/core` plus only the chart types and
 * components ChartKit actually renders (bar, line, pie; grid/tooltip/
 * legend/graphic-text), canvas renderer. Registering once here — imported
 * only by useEChart.ts — keeps every consumer off the ~1MB full bundle.
 */
import * as echarts from 'echarts/core';
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DatasetComponent,
  GraphicComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  BarChart,
  LineChart,
  PieChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DatasetComponent,
  GraphicComponent,
  CanvasRenderer,
]);

export { echarts };
export type { EChartsCoreOption, ECharts } from 'echarts/core';
